import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import ResetIp from "./views/ResetIp.vue";
import FastFormat from "./views/FastFormat.vue";
import CoverGenerator from "./views/CoverGenerator.vue";
import DyAvatarGenerator from "./views/DyAvatarGenerator";
import OrderRecord from "./views/OrderRecord.vue";
import UseRecord from "./views/UseRecord.vue";
import CtbUser from "./views/CtbUser.vue";
import WxGroup from "./views/WxGroup.vue";
import ServerLog from "./views/ServerLog.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/ResetIp",
      name: "ResetIp",
      component: ResetIp
    },
    {
      path: "/FastFormat",
      name: "FastFormat",
      component: FastFormat
    },
    {
      path: "/CoverGenerator",
      name: "CoverGenerator",
      component: CoverGenerator
    },
    {
      path: "/DyAvatarGenerator",
      name: "DyAvatarGenerator",
      component: DyAvatarGenerator
    },
    {
      path: "/WxGroup",
      name: "WxGroup",
      component: WxGroup
    },
    {
      path: "/OrderRecord",
      name: "OrderRecord",
      component: OrderRecord
    },
    {
      path: "/UseRecord",
      name: "UseRecord",
      component: UseRecord
    },
    {
      path: "/CtbUser",
      name: "CtbUser",
      component: CtbUser
    },
    {
      path: "/ServerLog",
      name: "ServerLog",
      component: ServerLog
    },
  ]
});

export default router;
